// extracted by mini-css-extract-plugin
export default {"h1Title":"errors_h1Title__Ty8nu","image":"errors_image__63ogX","wrap":"errors_wrap__mcNwY","text":"errors_text__NIkEE","hint":"errors_hint__NjHXI","support":"errors_support__Mg1lv"};